module.exports = __webpack_public_path__ + "static/media/voidcheque.3a9d7da1.PNG";